import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Tour, TourStep, Button} from 'kpc';

var _$tmp0 = {
    'style': 'margin-top: 20px;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Tour, {
            'visible': this.get('showTour'),
            'ev-finish': this.close,
            'children': [
                _$cc(TourStep, {
                    'title': '无目标元素-第一步',
                    'children': (
                        _$ce(2, 'span', '当没有指定target属性或者目标元素不存在时，Tour会居中显示在屏幕中央。', 16)
                    )
                }),
                _$cc(TourStep, {
                    'title': '无目标元素-第二步',
                    'children': (
                        _$ce(2, 'span', '当没有指定target属性或者目标元素不存在时，所有步骤都会居中显示在屏幕中央。', 16)
                    )
                })
            ],
            'ev-$model:value': function($v) {
                $this.set('currentStep', $v);
            },
            'value': $this.get('currentStep')
        }),
        _$ce(2, 'div', (
            _$cc(Button, {
                'ev-click': this.settour,
                'children': '\n            启动无目标引导\n        '
            })
        ), 2, null, _$tmp0)
    ], 4);
};